/* ============================================================
   rematech · Comparador de equipos · COMPORTAMIENTO
   DS v2.0 · pareja de sections/rt-comparador.liquid
   ============================================================

   ÚNICA FUENTE DE VERDAD DEL COMPARADOR
   Un solo localStorage, un solo botón flotante, un solo panel.
   Si algo del comparador falla, empieza por aquí.

   ── DE DÓNDE SALEN LOS EQUIPOS ──────────────────────────────
   Tres orígenes, en este orden:

     1. Los que el usuario marcó con "+ Comparar" en una tarjeta.
     2. Los que trae en el carrito (hasta llenar el cupo de 3).
     3. Los que elige en el buscador de este mismo panel.

   El 2 existe porque comparar es una decisión de última hora: si
   ya metiste dos laptops al carrito, seguramente estás decidiendo
   entre ellas. Obligarte a marcarlas otra vez sería trabajo doble.

   ── POR QUÉ HAY QUE PEDIR /products/{handle}.js ─────────────
   La búsqueda predictiva de Shopify devuelve `variants` sólo
   cuando la consulta coincide con el título de una variante, y aun
   así devuelve UNA sola. No sirve para saber si un equipo está
   disponible ni cuánto cuesta la variante más cara.

   El único origen fiable de `available` y `price` por variante es
   /products/{handle}.js. Por eso cada resultado se hidrata después
   de pintarse: primero aparece la fila, luego se corrige el precio.
   Se aprendió a la mala en la barra de búsqueda del sitio.

   ── REGLA DE PRECIO ─────────────────────────────────────────
   El precio mostrado es el MÁS ALTO entre las variantes
   DISPONIBLES. La misma del carril y del buscador: si el
   comparador mostrara otra cifra, contradiría a la tarjeta desde
   la que llegaste.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-rtc-root]');
  if (!root) return;

  /* Una sola inicialización aunque la sección se incluya dos veces.
     Sin esta guarda habría dos listeners por click y el contador
     saltaría de dos en dos. */
  if (window.__rtcReady) return;
  window.__rtcReady = true;

  // ══════════════════════════════════════════════════════════════
  // CONFIGURACIÓN
  // ══════════════════════════════════════════════════════════════
  var CFG = {};
  try { CFG = JSON.parse(root.getAttribute('data-rtc-config') || '{}'); } catch (e) { CFG = {}; }

  var MAX        = parseInt(CFG.max, 10) || 3;
  var CART_SYNC  = CFG.cartSync !== false;
  var WA         = CFG.whatsapp || '';
  var MSI_MONTHS = parseInt(CFG.msiMonths, 10) || 0;
  var LS         = 'rtCompare';
  var CACHE_LS   = 'rtCardCache';
  var DISMISS_LS = 'rtCompareDismissed';

  // Raíz con prefijo de idioma. Sin esto, en /es o /mx las peticiones
  // van a la ruta equivocada y devuelven 404 en silencio.
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ══════════════════════════════════════════════════════════════
  // UTILIDADES
  // ══════════════════════════════════════════════════════════════
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function readLS(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key) || fallback); }
    catch (e) { return JSON.parse(fallback); }
  }
  function writeLS(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Se escapa PRIMERO y se marca después, sobre texto ya seguro.
     Al revés, un título con < o > rompería el marcado o abriría la
     puerta a inyección. */
  function highlight(text, q) {
    var safe = escapeHtml(text);
    if (!q) return safe;
    var i = safe.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return safe;
    return safe.slice(0, i) + '<mark>' + safe.slice(i, i + q.length) + '</mark>' + safe.slice(i + q.length);
  }

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '$' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 0, maximumFractionDigits: 0
    });
  }

  function stripTags(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html || '');
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // ══════════════════════════════════════════════════════════════
  // ESTADO
  // ══════════════════════════════════════════════════════════════
  var list = readLS(LS, '[]')
    .filter(function (it) { return it && typeof it === 'object' && it.handle; })
    .slice(0, MAX);

  var replaceSlot = null;   // índice que se está sustituyendo, o null
  var showAll     = false;  // toggle "mostrar todo / sólo diferencias"

  function save() { writeLS(LS, list); }

  function getCache()  { return readLS(CACHE_LS, '{}'); }
  function cacheCard(entry) {
    if (!entry || !entry.handle) return;
    var map = getCache();
    map[entry.handle] = entry;
    writeLS(CACHE_LS, map);
  }

  /* Lista de "no me lo vuelvas a meter". Si quitas del comparador un
     equipo que está en tu carrito, sin esto la sincronización lo
     regresaría en la siguiente carga y parecería que el botón de
     quitar no sirve. */
  function getDismissed() { return readLS(DISMISS_LS, '[]'); }
  function dismiss(h) {
    var arr = getDismissed();
    if (arr.indexOf(h) === -1) { arr.push(h); writeLS(DISMISS_LS, arr); }
  }
  function undismiss(h) {
    writeLS(DISMISS_LS, getDismissed().filter(function (x) { return x !== h; }));
  }

  // ══════════════════════════════════════════════════════════════
  // NODOS
  // ══════════════════════════════════════════════════════════════
  var fab      = $('#rtcFab');
  var fabCount = $('#rtcCount');
  var overlay  = $('#rtcOverlay');
  var sheet    = $('#rtcSheet');
  var body     = $('#rtcBody');
  var toastEl  = $('#rtcToast');
  var sheetSub = $('#rtcSheetSub');
  var toggleEl = $('#rtcToggleDiff');
  var clearEl  = $('#rtcClearAll');

  var smBg     = $('#rtcSmBg');
  var smBox    = $('#rtcSm');
  var smInput  = $('#rtcSmInput');
  var smResults= $('#rtcSmResults');
  var smMeta   = $('#rtcSmMeta');
  var smClear  = $('#rtcSmClear');
  var smTtl    = $('#rtcSmTtl');
  var smSub    = $('#rtcSmSub');

  if (!fab || !sheet || !smBox) return;

  fab.classList.add('is-ready');

  // ══════════════════════════════════════════════════════════════
  // TOAST
  // ══════════════════════════════════════════════════════════════
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2400);
  }

  // ══════════════════════════════════════════════════════════════
  // LECTURA DE TARJETAS
  // ══════════════════════════════════════════════════════════════
  var SCOPES = ['[data-rt-compare-scope]', 'product-recommendations', '.related-products'];

  function handleFrom(a) {
    var m = /\/products\/([a-z0-9\-_%]+)/i.exec(a.getAttribute('href') || '');
    return m ? decodeURIComponent(m[1].split('?')[0]) : null;
  }

  /* Los data-* de la tarjeta son la fuente rica: specs, calificación
     y categoría sólo existen ahí, porque salen de metafields que ni
     el carrito ni la búsqueda predictiva devuelven. */
  function readCard(a, h) {
    var img     = a.querySelector('img');
    var titleEl = a.querySelector('.pr-title') || a.querySelector('[class*="title"]');
    var priceEl = a.querySelector('.price-hero') || a.querySelector('[class*="price"]');
    var specsEl = a.querySelector('.specs') || a.querySelector('.pr-specs');

    var cents   = a.dataset.priceCents ? parseInt(a.dataset.priceCents, 10) : NaN;
    var rating  = a.dataset.rating ? parseFloat(a.dataset.rating) : NaN;
    var reviews = a.dataset.reviews ? parseInt(a.dataset.reviews, 10) : NaN;

    return {
      handle:     h,
      url:        a.getAttribute('href') || (ROOT + 'products/' + h),
      title:      titleEl ? titleEl.textContent.trim() : (img ? img.alt : h),
      image:      img ? (img.currentSrc || img.src) : '',
      priceText:  priceEl ? priceEl.textContent.trim() : '',
      priceCents: isNaN(cents) ? null : cents,
      rating:     (isNaN(rating) || rating <= 0) ? null : rating,
      reviews:    (isNaN(reviews) || reviews <= 0) ? null : reviews,
      specs:      a.dataset.specs || (specsEl ? specsEl.textContent.trim() : ''),
      category:   a.dataset.cat || '',
      /* Precio de referencia contra nuevo. Lo emite la tarjeta; si
         falta, la fila de precio simplemente no muestra el ahorro. */
      compareCents: a.dataset.compareCents ? parseInt(a.dataset.compareCents, 10) : null
    };
  }

  function syncButtons() {
    $$('.rtc-btn').forEach(function (b) {
      var on = list.some(function (it) { return it.handle === b.dataset.handle; });
      b.textContent = on ? '✓' : '+';
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    /* Los botones nativos del Pcard v2.2. Se marcan con las DOS
       señales porque el CSS de la tarjeta lee aria-pressed y is-active
       por separado, y basta con que una llegue. */
    $$('[data-compare-btn]').forEach(function (b) {
      var a = b.closest('a[href*="/products/"]');
      var h = a ? handleFrom(a) : null;
      var on = h ? list.some(function (it) { return it.handle === h; }) : false;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function attach() {
    var sel = SCOPES.map(function (s) { return s + ' a[href*="/products/"]'; }).join(',');
    $$(sel).forEach(function (a) {
      var h = handleFrom(a);
      var img = a.querySelector('img');
      if (!h || !img) return;

      // Siempre se cachea, aunque ya esté enganchada: así el
      // comparador tiene specs de cualquier equipo que hayas visto.
      cacheCard(readCard(a, h));

      if (a.dataset.rtcDone) return;
      a.dataset.rtcDone = '1';

      /* Si la tarjeta ya trae su botón, se engancha ESE. Antes se
         inyectaba el círculo flotante sin preguntar y quedaban dos
         botones de comparar encimados sobre la foto. */
      var native = a.querySelector('[data-compare-btn]');
      if (native) {
        native.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          undismiss(h);
          toggleItem(h, a);
        });
        return;
      }

      var holder = img.parentElement || a;
      if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rtc-btn';
      b.dataset.handle = h;
      b.setAttribute('aria-label', 'Comparar');
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        undismiss(h);
        toggleItem(h, a);
      });
      holder.appendChild(b);
    });
    syncButtons();
  }

  function toggleItem(h, cardEl) {
    var i = list.findIndex(function (it) { return it.handle === h; });
    if (i !== -1) {
      list.splice(i, 1);
      dismiss(h);
    } else if (list.length < MAX) {
      list.push(cardEl ? readCard(cardEl, h) : { handle: h, url: ROOT + 'products/' + h, title: h });
    } else {
      toast('Máximo ' + MAX + ' equipos para comparar');
      return;
    }
    save(); updateFab(); syncButtons();
    if (sheet.classList.contains('is-open')) render();
  }

  // ══════════════════════════════════════════════════════════════
  // BOTÓN FLOTANTE
  // ══════════════════════════════════════════════════════════════
  function updateFab() {
    fabCount.textContent = list.length + ' / ' + MAX;
    fab.classList.toggle('is-active', list.length > 0);
  }

  fab.addEventListener('click', function (e) { e.preventDefault(); openSheet(); });

  // Si el tema muestra una barra inferior fija, el FAB se levanta.
  var bottomBar = $('#rtsBar');
  if (bottomBar && window.MutationObserver) {
    var lift = function () {
      fab.classList.toggle('is-lifted', bottomBar.classList.contains('is-visible'));
    };
    new MutationObserver(lift).observe(bottomBar, { attributes: true, attributeFilter: ['class'] });
    lift();
  }

  // ══════════════════════════════════════════════════════════════
  // HOJA
  // ══════════════════════════════════════════════════════════════
  var lastFocusSheet = null;

  function openSheet() {
    lastFocusSheet = document.activeElement;
    overlay.classList.add('is-open');
    sheet.classList.add('is-open');

    /* .rtc-open en <html> hace dos cosas:
         · bloquea el scroll de la página detrás
         · baja el header a la capa 1 (ver rmt-compare.css)

       Lo segundo existe porque el header del sitio es sticky con
       z-index 500 e !important: sin esto, la página se oscurece pero
       el header sigue brillando encima, y parece que el oscurecido
       falló cuando en realidad es orden de pintado. */
    document.documentElement.classList.add('rtc-open');
    document.documentElement.style.overflow = 'hidden';
    render();
    setTimeout(function () {
      var c = $('#rtcClose');
      if (c) c.focus();
    }, 60);
  }

  function closeSheet() {
    overlay.classList.remove('is-open');
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('rtc-open');
    document.documentElement.style.overflow = '';
    if (lastFocusSheet && lastFocusSheet.focus) lastFocusSheet.focus();
  }

  $('#rtcClose').addEventListener('click', closeSheet);
  overlay.addEventListener('click', closeSheet);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // El buscador se abre DESDE la hoja, así que Escape cierra
    // primero el de encima. Si cerrara los dos, volverías al catálogo
    // habiendo perdido la comparación que estabas armando.
    if (smBox.classList.contains('is-open')) { closeSearch(); return; }
    if (sheet.classList.contains('is-open')) closeSheet();
  });

  if (toggleEl) {
    toggleEl.addEventListener('change', function (e) {
      showAll = e.target.checked;
      root.classList.toggle('show-all', showAll);
    });
  }

  if (clearEl) {
    clearEl.addEventListener('click', function () {
      list.forEach(function (it) { dismiss(it.handle); });
      list = [];
      save(); updateFab(); syncButtons(); render();
    });
  }

  // ══════════════════════════════════════════════════════════════
  // TABLA
  // ══════════════════════════════════════════════════════════════

  /* Las filas se declaran como datos y no como HTML suelto para que
     agregar una característica sea agregar un objeto, no tocar el
     render. `has` decide si la fila existe: si ningún equipo tiene
     ese dato, la fila entera no se pinta — mejor eso que tres
     guiones en fila. */
  var ROWS = [
    {
      /* DESDE · el precio y, pegado, cuánto se ahorra contra nuevo.
         El ahorro no va en fila aparte: separados, el usuario tiene
         que recordar una cifra mientras baja a buscar la otra. */
      id: 'price', label: 'Desde',
      has:  function (l) { return l.some(function (it) { return it.priceCents != null || it.priceText; }); },
      cell: function (it, l) {
        var vals = l.map(function (x) { return x.priceCents; }).filter(function (v) { return v != null; });
        var best = vals.length > 1 ? Math.min.apply(null, vals) : null;
        var isBest = best != null && it.priceCents === best &&
                     vals.filter(function (v) { return v === best; }).length === 1;

        var html = '<span class="rtc-price">' + escapeHtml(it.priceText || money(it.priceCents) || '—') + '</span>';

        // Sólo si la referencia SUPERA al precio. Un ahorro negativo
        // no se muestra: sería anunciar que sale más caro que nuevo.
        if (it.compareCents != null && it.priceCents != null && it.compareCents > it.priceCents) {
          var off = Math.round((1 - it.priceCents / it.compareCents) * 100);
          html += '<span class="rtc-off">&minus;' + off + '% vs nuevo</span>';
        }
        if (isBest) html += '<span class="rtc-flag">Más accesible</span>';
        return { html: html };
      }
    },
    {
      /* MSI · va justo después del precio porque responde a la
         siguiente pregunta que se hace quien acaba de ver la cifra:
         "¿y cuánto me sale al mes?". Al final de la tabla llegaba
         demasiado tarde para influir en la decisión. */
      id: 'msi', label: 'Mensualidad',
      has:  function (l) { return MSI_MONTHS > 0 && l.some(function (it) { return it.priceCents != null; }); },
      cell: function (it) {
        if (it.priceCents == null) return { html: '<span class="rtc-val">—</span>', muted: true };
        var per = Math.round(it.priceCents / MSI_MONTHS);
        return {
          html: '<span class="rtc-msi">' + money(per) + '</span>' +
                '<span class="rtc-msi-sub">&times; ' + MSI_MONTHS + ' meses</span>'
        };
      }
    },
    {
      id: 'rating', label: 'Reseñas',
      has:  function (l) { return l.some(function (it) { return it.rating != null; }); },
      cell: function (it, l) {
        if (it.rating == null) return { html: '<span class="rtc-val">Sin reseñas</span>', muted: true };
        var vals = l.map(function (x) { return x.rating; }).filter(function (v) { return v != null; });
        var best = vals.length > 1 ? Math.max.apply(null, vals) : null;
        var isBest = best != null && it.rating === best &&
                     vals.filter(function (v) { return v === best; }).length === 1;
        return {
          html: '<span class="rtc-rate"><span class="st">&#9733;</span>' + it.rating + '</span>' +
                (it.reviews ? '<span class="rtc-rate-sub">(' + it.reviews + ' reseñas)</span>' : '') +
                (isBest ? '<span class="rtc-flag">Mejor calificado</span>' : '')
        };
      }
    },
    {
      id: 'category', label: 'Característica',
      has:  function (l) { return l.some(function (it) { return it.category; }); },
      cell: function (it) { return { html: '<span class="rtc-val">' + escapeHtml(it.category || '—') + '</span>' }; },
      same: function (l) { return l.map(function (it) { return it.category || ''; }); }
    },
    {
      id: 'specs', label: 'Ficha técnica',
      has:  function (l) { return l.some(function (it) { return it.specs; }); },
      cell: function (it) { return { html: '<span class="rtc-val">' + escapeHtml(it.specs || '—') + '</span>' }; },
      same: function (l) { return l.map(function (it) { return it.specs || ''; }); }
    }
  ];

  function rowIsSame(row, l) {
    if (!row.same || l.length < 2) return false;
    var vals = row.same(l);
    return vals.every(function (v) { return v === vals[0]; });
  }

  function headerCell(it, idx) {
    /* El rating salió de aquí y ahora es una fila propia debajo del
       precio. En el encabezado competía con el nombre y la ficha
       técnica por tres líneas de alto, y ninguna de las tres se leía
       bien. Como fila tiene su espacio y se compara de un vistazo. */
    return '' +
      '<div class="rtc-cell rtc-phead">' +
        '<span class="rtc-photo">' +
          '<span class="rtc-cert">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true">' +
              '<path d="M12 2L4 5v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V5l-8-3z" stroke-linejoin="round"/>' +
              '<path d="M9 12l2 2 4-4" stroke-linecap="round"/>' +
            '</svg>Cert' +
          '</span>' +
          '<button type="button" class="rtc-x" data-remove="' + idx + '" aria-label="Quitar ' + escapeHtml(it.title) + '">×</button>' +
          (it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">' : '') +
        '</span>' +
        (it.fromCart ? '<span class="rtc-badge-cart">En tu carrito</span>' : '') +
        '<span class="rtc-pname">' + escapeHtml(it.title) + '</span>' +
        (it.specs ? '<span class="rtc-pspecs">' + escapeHtml(it.specs) + '</span>' : '') +
        '<button type="button" class="rtc-change" data-change="' + idx + '">Cambiar</button>' +
      '</div>';
  }

  function emptySlot(idx) {
    return '' +
      '<button type="button" class="rtc-slot" data-add="' + idx + '">' +
        '<span class="plus" aria-hidden="true">＋</span>' +
        '<span class="lbl">Agregar equipo</span>' +
      '</button>';
  }

  function render() {
    if (!list.length) {
      body.innerHTML =
        '<div class="rtc-empty">' +
          'Marca hasta <b>' + MAX + '</b> equipos con el botón <b>+ Comparar</b> de las tarjetas, ' +
          'o búscalos aquí abajo.' +
        '</div>' +
        '<div class="rtc-grid">' + emptySlot(0) + emptySlot(1) + emptySlot(2) + '</div>';
      wire();
      if (sheetSub) sheetSub.textContent = 'Ningún equipo seleccionado';
      return;
    }

    var html = '<div class="rtc-grid">';

    // Encabezados · siempre tres columnas, aunque falten equipos
    for (var i = 0; i < MAX; i++) {
      html += i < list.length ? headerCell(list[i], i) : emptySlot(i);
    }

    ROWS.forEach(function (row) {
      if (!row.has(list)) return;
      var same = rowIsSame(row, list);
      var cls  = same ? ' rtc-row-same' : '';

      html += '<div class="rtc-subhead' + cls + '">' + row.label + '</div>';

      for (var j = 0; j < MAX; j++) {
        if (j < list.length) {
          var out = row.cell(list[j], list) || {};
          html += '<div class="rtc-cell' + cls +
                  (out.best ? ' is-best' : '') +
                  (out.muted ? ' rtc-cell--muted' : '') + '">' +
                  (out.html || '') + '</div>';
        } else {
          html += '<div class="rtc-cell rtc-cell--muted' + cls + '">—</div>';
        }
      }
    });

    // CTA · una sola fila que ocupa las tres columnas y se pega abajo
    html += '<div class="rtc-cta-row" id="rtcCtaRow">';
    for (var k = 0; k < MAX; k++) {
      html += k < list.length
        ? '<a class="rtc-buy" href="' + escapeHtml(list[k].url) + '">Ver equipo</a>'
        : '<span class="rtc-buy rtc-ghost" aria-hidden="true">Ver equipo</span>';
    }
    html += '</div><div class="rtc-sentinel" id="rtcSentinel"></div>';

    html += '</div>';
    body.innerHTML = html;

    if (sheetSub) {
      sheetSub.textContent = list.length === 1
        ? '1 equipo · agrega otro para comparar'
        : list.length + ' equipos lado a lado';
    }

    wire();
    watchCta();
  }

  function wire() {
    $$('[data-remove]', body).forEach(function (b) {
      b.addEventListener('click', function () {
        var it = list[parseInt(b.dataset.remove, 10)];
        if (!it) return;
        toggleItem(it.handle, null);
        if (!list.length) render();
      });
    });
    $$('[data-change]', body).forEach(function (b) {
      b.addEventListener('click', function () {
        replaceSlot = parseInt(b.dataset.change, 10);
        openSearch();
      });
    });
    $$('[data-add]', body).forEach(function (b) {
      b.addEventListener('click', function () {
        replaceSlot = null;
        openSearch();
      });
    });
  }

  /* El CTA es sticky mientras haya tabla debajo y deja de serlo al
     llegar a su lugar natural. Sin esto, al final del scroll se ve
     una barra con sombra flotando sobre nada. */
  var ctaObserver = null;
  function watchCta() {
    if (ctaObserver) ctaObserver.disconnect();
    var sentinel = $('#rtcSentinel', body);
    var ctaRow   = $('#rtcCtaRow', body);
    if (!sentinel || !ctaRow || !window.IntersectionObserver) return;
    ctaObserver = new IntersectionObserver(function (entries) {
      ctaRow.classList.toggle('is-parked', entries[0].isIntersecting);
    }, { root: body, threshold: 0 });
    ctaObserver.observe(sentinel);
  }

  // ══════════════════════════════════════════════════════════════
  // BUSCADOR
  // ══════════════════════════════════════════════════════════════
  var smActive = -1;
  var lastFocusSm = null;
  var searchSeq = 0;   // guarda contra respuestas fuera de orden

  function openSearch() {
    lastFocusSm = document.activeElement;
    var replacing = replaceSlot !== null;
    smTtl.textContent = replacing ? 'Cambiar equipo' : 'Agregar equipo';
    smSub.textContent = replacing
      ? 'Sustituye el de la columna ' + (replaceSlot + 1)
      : 'Elige cuál quieres comparar';

    smBg.classList.add('is-open');
    smBox.classList.add('is-open');
    smInput.value = '';
    smClear.hidden = true;
    smActive = -1;
    smMeta.textContent = '';
    smResults.innerHTML = '<div class="rtc-sm-hint">Escribe el modelo, la marca o una spec.<br>Por ejemplo <b>MacBook</b>, <b>i7</b> o <b>16 GB</b>.</div>';
    setTimeout(function () { smInput.focus(); }, 60);
  }

  function closeSearch() {
    smBg.classList.remove('is-open');
    smBox.classList.remove('is-open');
    replaceSlot = null;
    smActive = -1;
    if (lastFocusSm && lastFocusSm.focus) lastFocusSm.focus();
  }

  smBg.addEventListener('click', closeSearch);
  $('#rtcSmClose').addEventListener('click', closeSearch);
  smClear.addEventListener('click', function () {
    smInput.value = '';
    smClear.hidden = true;
    smActive = -1;
    smMeta.textContent = '';
    smResults.innerHTML = '<div class="rtc-sm-hint">Escribe el modelo, la marca o una spec.</div>';
    smInput.focus();
  });

  /* Búsqueda predictiva oficial de Shopify.
     limit_scope=each y unavailable_products=show para que los
     agotados también aparezcan: si un equipo no sale, el usuario
     asume que no lo tienes, cuando en realidad sólo está sin stock. */
  function predictive(query) {
    var url = ROOT + 'search/suggest.json' +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=8' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=show' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        return (d && d.resources && d.resources.results && d.resources.results.products) || [];
      });
  }

  /* El precio real y la disponibilidad SÓLO son fiables aquí. La
     búsqueda predictiva devuelve un precio que puede ser de una
     variante agotada. */
  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  // Precio: el MÁS ALTO entre las variantes DISPONIBLES.
  function priceOf(p) {
    if (!p || !p.variants) return null;
    var live = p.variants.filter(function (v) { return v.available === true; });
    if (!live.length) return null;
    return Math.max.apply(null, live.map(function (v) { return v.price; }));
  }

  function availabilityOf(p) {
    if (!p) return { cls: 'ok', txt: 'Ver' };
    var live = (p.variants || []).filter(function (v) { return v.available === true; });
    if (!live.length) return { cls: 'out', txt: 'Agotado' };
    return { cls: 'ok', txt: 'Disponible' };
  }

  /* La ficha técnica corta viene de la caché de tarjetas: son
     metafields, y ni la búsqueda ni products.js los devuelven. Si el
     equipo nunca se vio como tarjeta, se usa el inicio de la
     descripción, que al menos dice algo. */
  function specsFor(handle, fallbackBody) {
    var cached = getCache()[handle];
    if (cached && cached.specs) return cached.specs;
    var t = stripTags(fallbackBody);
    return t ? t.slice(0, 64) + (t.length > 64 ? '…' : '') : '';
  }

  function renderResults(query, products) {
    var q = query.trim();

    if (!products.length) {
      smMeta.textContent = 'Sin coincidencias';
      smResults.innerHTML =
        '<div class="rtc-sm-empty">' +
          '<div class="em-ttl">No encontramos "' + escapeHtml(q) + '"</div>' +
          '<div class="em-sub">Puede que hoy no lo tengamos. Dinos qué buscas y te avisamos cuando entre al catálogo.</div>' +
          (WA
            ? '<a class="em-cta" target="_blank" rel="noopener noreferrer" href="https://wa.me/' + encodeURIComponent(WA) +
              '?text=' + encodeURIComponent('Hola, busqué "' + q + '" y no lo encontré. ¿Me avisan cuando llegue?') +
              '">Avísame por WhatsApp</a>'
            : '') +
        '</div>';
      return;
    }

    smMeta.textContent = products.length + (products.length === 1 ? ' resultado' : ' resultados');

    smResults.innerHTML = products.map(function (p) {
      var picked = list.some(function (it) { return it.handle === p.handle; });
      var full   = list.length >= MAX && replaceSlot === null;
      var dis    = picked || (full && !picked);
      var specs  = specsFor(p.handle, p.body);

      return '<button type="button" role="option" aria-selected="false"' +
             ' class="rtc-sr' + (picked ? ' is-picked' : '') + '"' +
             (dis ? ' disabled' : '') +
             ' data-pick="' + escapeHtml(p.handle) + '"' +
             ' data-title="' + escapeHtml(p.title) + '"' +
             ' data-url="' + escapeHtml(p.url || (ROOT + 'products/' + p.handle)) + '"' +
             ' data-img="' + escapeHtml((p.featured_image && p.featured_image.url) || p.image || '') + '">' +
        '<span class="rtc-sr-photo">' +
          ((p.featured_image && p.featured_image.url) || p.image
            ? '<img src="' + escapeHtml((p.featured_image && p.featured_image.url) || p.image) + '" alt="" loading="lazy">'
            : '') +
        '</span>' +
        '<span class="rtc-sr-info">' +
          '<span class="rtc-sr-name">' + highlight(p.title, q) + '</span>' +
          (specs ? '<span class="rtc-sr-desc">' + escapeHtml(specs) + '</span>' : '') +
          '<span class="rtc-sr-row" data-slot="' + escapeHtml(p.handle) + '">' +
            '<span class="rtc-chip ok">' + (picked ? 'Ya en comparación' : 'Cargando…') + '</span>' +
          '</span>' +
        '</span>' +
      '</button>';
    }).join('');

    $$('[data-pick]', smResults).forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.disabled) return;
        pickResult(item);
      });
    });

    // Hidratación · la fila ya está en pantalla y se corrige en su
    // lugar. Pintar primero y corregir después se siente más rápido
    // que esperar a tener todo antes de mostrar nada.
    products.forEach(function (p) {
      if (list.some(function (it) { return it.handle === p.handle; })) return;
      fetchProduct(p.handle).then(function (full) {
        var slot = smResults.querySelector('[data-slot="' + CSS.escape(p.handle) + '"]');
        if (!slot) return;
        var cents = priceOf(full);
        var av    = availabilityOf(full);
        slot.innerHTML =
          (cents != null ? '<span class="rtc-sr-price">' + money(cents) + '</span>' : '') +
          '<span class="rtc-chip ' + av.cls + '">' + av.txt + '</span>';
        var btn = slot.closest('[data-pick]');
        if (btn) btn.dataset.cents = cents == null ? '' : cents;
      });
    });
  }

  function pickResult(item) {
    var h = item.dataset.pick;
    if (list.some(function (it) { return it.handle === h; })) return;

    var cached = getCache()[h] || {};
    var entry = {
      handle:     h,
      url:        item.dataset.url,
      title:      cached.title || item.dataset.title,
      image:      cached.image || item.dataset.img,
      priceCents: item.dataset.cents ? parseInt(item.dataset.cents, 10) : (cached.priceCents || null),
      priceText:  '',
      rating:     cached.rating != null ? cached.rating : null,
      reviews:    cached.reviews != null ? cached.reviews : null,
      specs:      cached.specs || '',
      category:   cached.category || ''
    };
    if (entry.priceCents != null) entry.priceText = money(entry.priceCents);

    undismiss(h);
    if (replaceSlot !== null && replaceSlot < list.length) {
      dismiss(list[replaceSlot].handle);
      list[replaceSlot] = entry;
    } else if (list.length < MAX) {
      list.push(entry);
    } else {
      toast('Máximo ' + MAX + ' equipos para comparar');
      return;
    }

    closeSearch();
    save(); updateFab(); syncButtons(); render();
  }

  function moveActive(delta) {
    var items = $$('.rtc-sr:not([disabled])', smResults);
    if (!items.length) return;
    items.forEach(function (i) {
      i.classList.remove('is-active');
      i.setAttribute('aria-selected', 'false');
    });
    smActive = (smActive + delta + items.length) % items.length;
    var el = items[smActive];
    el.classList.add('is-active');
    el.setAttribute('aria-selected', 'true');
    el.scrollIntoView({ block: 'nearest' });
  }

  /* Debounce de 220 ms: escribir "macbook" dispararía siete peticiones
     sin esto. Y el contador de secuencia descarta respuestas que
     llegan tarde — sin él, una consulta lenta de "mac" puede pisar
     los resultados de "macbook". */
  var typeTimer;
  smInput.addEventListener('input', function (e) {
    var q = e.target.value;
    smClear.hidden = !q;
    clearTimeout(typeTimer);

    if (!q.trim()) {
      smMeta.textContent = '';
      smResults.innerHTML = '<div class="rtc-sm-hint">Escribe el modelo, la marca o una spec.</div>';
      return;
    }

    smResults.innerHTML = '<div class="rtc-skel"></div><div class="rtc-skel"></div><div class="rtc-skel"></div>';
    smMeta.textContent = 'Buscando…';

    typeTimer = setTimeout(function () {
      var seq = ++searchSeq;
      predictive(q).then(function (products) {
        if (seq !== searchSeq) return;
        renderResults(q, products);
      }).catch(function () {
        if (seq !== searchSeq) return;
        smMeta.textContent = '';
        smResults.innerHTML = '<div class="rtc-sm-hint">No se pudo buscar en este momento. Revisa tu conexión.</div>';
      });
    }, 220);
  });

  smInput.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown')    { e.preventDefault(); moveActive(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(-1); }
    else if (e.key === 'Enter') {
      var el = smResults.querySelector('.rtc-sr.is-active') ||
               smResults.querySelector('.rtc-sr:not([disabled])');
      if (el) { e.preventDefault(); pickResult(el); }
    }
  });

  // ══════════════════════════════════════════════════════════════
  // CARRITO
  // ══════════════════════════════════════════════════════════════
  function cartEntry(item) {
    var cached = getCache()[item.handle];
    var base = cached ? JSON.parse(JSON.stringify(cached)) : {
      handle: item.handle,
      url: item.url || (ROOT + 'products/' + item.handle),
      title: item.product_title || item.handle,
      image: item.image || '',
      rating: null, reviews: null, specs: '', category: item.product_type || ''
    };
    base.priceCents = item.final_price;
    base.priceText  = money(item.final_price);
    base.url        = item.url || base.url;
    base.fromCart   = true;
    return base;
  }

  function syncCart() {
    if (!CART_SYNC) return;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var dismissed = getDismissed();
        var seen = {};
        var handles = [];
        // De atrás hacia adelante: lo último agregado es lo que el
        // usuario tiene más presente.
        for (var i = cart.items.length - 1; i >= 0; i--) {
          var h = cart.items[i].handle;
          if (!seen[h] && dismissed.indexOf(h) === -1) { seen[h] = true; handles.push(h); }
        }

        // Se sueltan los que venían del carrito y ya no están.
        list = list.filter(function (it) {
          return !it.fromCart || handles.indexOf(it.handle) !== -1;
        });

        handles.forEach(function (h) {
          var item = cart.items.filter(function (x) { return x.handle === h; })[0];
          var idx  = list.findIndex(function (it) { return it.handle === h; });
          if (idx !== -1) {
            list[idx] = cartEntry(item);
          } else if (list.length < MAX) {
            list.unshift(cartEntry(item));
          }
        });

        if (list.length > MAX) list = list.slice(0, MAX);
        save(); updateFab(); syncButtons();
        if (sheet.classList.contains('is-open')) render();
      })
      .catch(function () {});
  }

  // ══════════════════════════════════════════════════════════════
  // ARRANQUE
  // ══════════════════════════════════════════════════════════════
  updateFab();
  attach();
  syncCart();

  /* Las tarjetas llegan en momentos distintos: al parsear el HTML,
     al terminar de cargar, y después con filtros AJAX o paginación.
     El observador cubre lo último; los dos primeros son para que el
     botón responda desde el primer instante. */
  if (window.MutationObserver) {
    var moTimer;
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(attach, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('load', function () { attach(); syncCart(); });

})();